import React from 'react';
// import PropTypes from 'prop-types';

function Privacy() {
  return (
    <div className="space-y-3 font-light text-justify">
      <p className="text-xl font-semibold">
        <strong>AYOS PRIVACY NOTICE </strong>
      </p>
      <p>
        <span>
          Ayos is a mobile gaming platform developed by Multisys Technologies
          Corporation containing both single player and multiplayer games.&nbsp;
        </span>
        It is connected to the Gamebox Admin Core system that allows game
        management; monitoring of transactions and its end-users. It has a
        gaming lobby where players can experience the fun and excitement of
        playing classic Filipino games by buying gems.
      </p>
      <p>
        At Multisys, we recognize the importance of data privacy and are
        committed to protecting your personal data. In line with this, we ensure
        that we comply with the Data Privacy Act of 2012 (RA 10173), along with
        its Implementing Rules and Regulations as well as any other relevant
        data privacy related laws and issuances by the National Privacy
        Commission. Furthermore, we only collect and process information that is
        necessary to fulfill the purpose of our platform. This Privacy Notice
        explains what information we collect, process, and share. It also
        informs you why we do so, and your data privacy rights with regard to
        your information.
      </p>
      <p className="text-lg font-medium">
        <strong>HOW YOUR PERSONAL DATA IS COLLECTED</strong>
      </p>
      <p>
        No information from users will be collected until they have given their
        express consent. The information we collect from our partners and game
        providers in order to register an account within the platform are as
        follow:
      </p>
      <ul className="list-disc pl-6 ml-6">
        <li>
          Code Name [in-game identifier: to be seen by other players in
          multiplayer matches]
        </li>
        <li>Mobile Number</li>
      </ul>
      <p>
        For customer service, Ayos may also require the following information
        from end-users in cases of account concerns or complaints:
      </p>
      <ul className="list-disc pl-6 ml-6">
        <li>Valid ID / Proof of identity </li>
        <li>Mobile Number</li>
        <li>Email Address</li>
        <li>Location - in case of delayed SMS or network disturbances</li>
        <li>Full Name</li>
      </ul>
      <p>
        All information will only be collected from users voluntarily and only
        after their express consent has been provided.
      </p>
      <p className="text-lg font-medium">
        <strong>HOW WE USE YOUR PERSONAL DATA</strong>
      </p>
      <p>
        We will only use your Personal Data if we have valid reasons for doing
        so. We may not process or use your information without your express
        consent.
      </p>
      <p>
        Data will be used for the purpose of registering an account for
        end-users within the application. By registering an account, users may
        be able to enjoy and interact with the games they have chosen to avail
        of. This includes being able to play and interact with other users on
        the respective multiplayer platforms.
      </p>
      <p>
        Additionally, data collected shall also be used for the purposes of
        transaction history, issue/bug troubleshooting, email notifications, and
        data analytics to ensure that there is a smooth experience for all
        parties involved.
      </p>
      <p className="text-lg font-medium">
        <strong>WHO WE SHARE YOUR DATA WITH</strong>
      </p>
      <p>
        Data provided by users for the purpose of registering an account will
        not be shared with any parties outside of Multisys. Data from the end
        users of our partners will only be made available to game providers for
        the purposes of data analytics, game improvement, and troubleshooting.
        No information will be shared or disclosed to any other third parties or
        advertisers. All information shall be kept by Multisys Technologies
        Corporation and held with the utmost confidentiality.
      </p>
      <p className="text-lg font-medium">
        <strong>HOW LONG YOUR INFORMATION WILL BE KEPT</strong>
      </p>
      <p>
        User account information will be retained until 1 year of inactivity.
        Once your account has been inactive for 1 years, you will receive a
        notice that after 30 days, all of your information will be moved into
        the archives unless you wish to continue using Ayos.
      </p>
      <p>
        We place great importance on the security of the Personal Data that we
        hold, including the use of physical, technological and organizational
        measures to ensure your information is protected from unauthorized
        access and against unlawful processing, accidental loss, alteration,
        disclosure, destruction and damage. Once the retention period is over or
        if the data is no longer needed, we will automatically delete your
        relevant personal information.
      </p>
      <p className="text-lg font-medium">
        <strong>YOUR RIGHTS AS A DATA SUBJECT</strong>
      </p>
      <p>
        As a user of Ayos, you are entitled to the following data privacy
        rights:
      </p>
      <ul className="list-disc pl-6">
        <li>
          To be informed whether your Personal Information shall be, are being,
          or have been processed;
        </li>
        <li>
          To reasonable access any Personal Information collected and processed
          in duration of usage of application;
        </li>
        <li>
          To object or withhold consent with regards to the collection and
          processing of your Personal Data.
        </li>
        <li>
          To suspend, withdraw, or order the blocking, removal, or destruction
          of Personal Data from the relevant company’s filing system;
        </li>
        <li>
          To dispute the inaccuracy or error in Personal Data, and the relevant
          company shall correct it immediately and accordingly, upon the request
          unless the request is vexatious or otherwise unreasonable;
        </li>
        <li>
          To obtain a copy of the data in an electronic or structured format
          that is commonly used and allows for further use by the Data Subject;
        </li>
        <li>
          To be indemnified for any damages sustained pursuant to the provisions
          of the Data Privacy Act or Other Privacy Laws
        </li>
      </ul>
      <p>
        If you wish to exercise any of the rights set out above or require
        further information, you may contact us.
      </p>
      <p className="text-lg font-medium">
        <strong>CONTACT US</strong>
      </p>
      <p>
        Multisys Technologies is fully committed to protecting and maintaining
        your privacy. For any questions, concerns or clarifications regarding
        this privacy policy and how to exercise your rights as a data subject,
        you may contact our Data Protection Officer at dpo@multisyscorp.com or
        send a text at 09774885839. You may also get in touch with us at
        inquiry@multisyscorp.com or reach us at our main office at (02) 8835
        9697.
      </p>
    </div>
  );
}

Privacy.propTypes = {};

export default Privacy;
